import axios, { AxiosError } from "axios";
import { auth } from "../../utilities/firebase";

export const CLIENT_API_KEY_HEADER = "x-client-api-key";

const clientApiKey = process.env.REACT_APP_CLIENT_API_KEY;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL as string,
  headers: clientApiKey ? { [CLIENT_API_KEY_HEADER]: clientApiKey } : undefined,
});

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  ({ data }) => data,
  (error: AxiosError) => Promise.reject(error),
);

export default api;
